import React, {useState} from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { TypographyProps } from '@mui/material';

import {SetContextStringFunction} from "../../context/context";


type EditableTypographyProps = {
    children: string;
    setValueFunction: (value: string) => void;
    variant?: TypographyProps['variant'];
    textAlign?: TypographyProps['align'];

} & Omit<TypographyProps, 'variant' | 'align'>


const EditableTypography: React.FC<EditableTypographyProps> = ({
    children,
    setValueFunction,
    variant = 'body1',
    textAlign = 'left',
    ...kwargs
}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [localValue, setLocalValue] = useState(children);

    const handleTypographyClick = () => {
        setIsEditing(true);
    };

    const handleBlur = () => {
        setValueFunction(localValue);
        setIsEditing(false);
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setLocalValue(event.target.value)
    }

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            setValueFunction(localValue);
            setIsEditing(false);
        }
    }

    return isEditing ? (
        <TextField
            variant="outlined"
            value={localValue}
            onChange={handleChange}
            onKeyDown={handleKeyPress}
            onBlur={handleBlur}
            autoFocus
            fullWidth
        />
    ) : (
        <Typography
            variant={variant} textAlign={textAlign}
            onClick={handleTypographyClick}
            {...kwargs}
        >
            {children}
        </Typography>
    )

}

export default EditableTypography;

